import { Component } from "./Component";
import { vp } from "../managers/vp";
import { DomUtils } from "socios-tools/utils/DomUtils";
const mediaItemFactory = require("../../html/MediaItem.handlebars");
export class VideoEndScreen extends Component {
    constructor() {
        super(require("../../html/VideoEndScreen.handlebars")());
        this._closed = false;
    }
    init(listModel, onCloseClick) {
        const listHtml = this.getHtml('list');
        const restartBtn = this.getHtml('restart');
        DomUtils.empty(listHtml);
        if (!this._closed) {
            listModel.items.some((item, index) => {
                listHtml.appendChild(DomUtils.createElement('<div class="VideoEndScreen-item_wrap" >' + mediaItemFactory(item) + '</div>'));
                return index >= 5;
            });
            setTimeout(() => {
                vp.loadImagesInView();
            }, 1);
        }
        restartBtn.addEventListener('click', () => {
            this.close();
            if (onCloseClick) {
                onCloseClick();
            }
        });
    }
    close() {
        this._closed = true;
        this.html.style.display = 'none';
    }
}
